import Spare from "assets/unityMenu/Spare.png";
import SpareSelected from "assets/unityMenu/SpareSelected.png";
import Dense from "assets/unityMenu/Dense.png";
import DenseSelected from "assets/unityMenu/DenseSelected.png";
import DGS from "assets/unityMenu/3DGS.png";
import DGSSelected from "assets/unityMenu/3DGS_Selected.png";
import ModelsIcon from "assets/unityMenu/3D_icon.png";
import ModelsIconSelected from "assets/unityMenu/3D_iconOn.png";
import notesIcon from "assets/unityMenu/notes.png";
import CameraOn from "assets/unityMenu/CameraOn.png";
import CameraOff from "assets/unityMenu/CameraOff.png";
import IdleCameraOn from "assets/unityMenu/IdleCameraOn.png";
import IdleCameraOff from "assets/unityMenu/IdleCameraOff.png";
import WidgetSwitchOn from "assets/unityMenu/WidgetSwitchOn.png";
import WidgetSwitch from "assets/unityMenu/WidgetSwitch.png";
import { useUnityActions } from "hooks/unityActions";
import { FaCog } from "react-icons/fa";
import { useEffect } from "react";

const UnityIconButton = ({ icon, onBtnClick }: { icon: React.ReactNode, onBtnClick: any }) => {
  return (
    <button className="w-10 h-10 p-1" onClick={onBtnClick}>
      {typeof icon === "string" ? (
        <img src={icon} alt="icon" className="w-full h-full" />
      ) : (
        icon
      )}
    </button>
  );
};

const UnityActionsWindow = () => {
  const {
    modelDensity, setModelDensity,
    show3DModel, setShow3DModel,
    editingMode, setEditingMode,
    cameraMode, setCameraMode,
    idleCameraMode, setIdleCameraMode,
    widgetSwitch, setWidgetSwitch
  } = useUnityActions();

  const sendStateToUnity = (method: string, readyArguments: any) => {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({
        object: 'ReactUIManager',
        type: 'ReactUIManager',
        method: method,
        arguments: [JSON.stringify(readyArguments)]
      }));
    }
  };

  useEffect(() => {
    sendStateToUnity('SetToggleGroup', ['PointCloudMode', modelDensity]);
  }, [modelDensity]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['Show3DModel', show3DModel]);
  }, [show3DModel]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['EditingMode', editingMode]);
  }, [editingMode]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['ShowPhotoIcons', cameraMode]);
  }, [cameraMode]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['FlyByMode', idleCameraMode]);
  }, [idleCameraMode]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['ShowWidgets', widgetSwitch]);
  }, [widgetSwitch]);

  return (
    <div className="bg-dark/70 rounded-md flex gap-2 pr-1">
      <div className="bg-dark/40 rounded-md px-1">
        <UnityIconButton icon={modelDensity === 0 ? SpareSelected : Spare} onBtnClick={() => setModelDensity(0)} />
        <UnityIconButton icon={modelDensity === 1 ? DenseSelected : Dense} onBtnClick={() => setModelDensity(1)} />
        <UnityIconButton icon={modelDensity === 2 ? DGSSelected : DGS} onBtnClick={() => setModelDensity(2)} />
      </div>
      <UnityIconButton icon={show3DModel ? ModelsIconSelected : ModelsIcon} onBtnClick={() => setShow3DModel((prev) => !prev)} />
      <UnityIconButton icon={notesIcon} onBtnClick={() => sendStateToUnity('SetButton', 'AddNote')} />
      <UnityIconButton icon={<FaCog size={24} className={editingMode ? "text-green" : "text-white"} />} onBtnClick={() => setEditingMode((prev) => !prev)} />
      <div className={cameraMode ? "" : "crossedCamera"}>
        <UnityIconButton icon={CameraOn} onBtnClick={() => setCameraMode((prev) => !prev)} />
      </div>
      <UnityIconButton icon={idleCameraMode ? IdleCameraOff : IdleCameraOn} onBtnClick={() => setIdleCameraMode((prev) => !prev)} />
      <UnityIconButton icon={widgetSwitch ? WidgetSwitchOn : WidgetSwitch} onBtnClick={() => setWidgetSwitch((prev) => !prev)} />
    </div>
  );
};

export default UnityActionsWindow;
